import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { catchError, from, map, Observable, of, switchMap } from 'rxjs';

import { OrganisationRoleService } from '../../services/organisation-role.service';
import { handleHttpError } from '../../utils/api';
import { OrganisationRoleActions } from '../actions/organisation-role.actions';

@Injectable()
export class OrganisationRoleEffects {
      public constructor( private readonly actions$: Actions, private readonly service: OrganisationRoleService ) {}

        public get$: Observable<Action> = createEffect(() =>
          this.actions$.pipe(
            ofType(OrganisationRoleActions.get),
            switchMap(({ admin }) =>
              from(this.service.get(admin)).pipe(
                map((roles) => OrganisationRoleActions.getSuccess({ roles })),
                catchError((error) => of(OrganisationRoleActions.getFailure({ error }))),
              ),
            ),
          ),
        );
      
        public getFailure$ = createEffect(() =>
          this.actions$.pipe(
            ofType(OrganisationRoleActions.getFailure),
            map((error) => handleHttpError(error)),
          ),
        );
}